import './mobile-menu.scss';

import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import MobileBurgerMenuIcon from '@/media/icons/mobile-burger-menu.svg?react';
import { LocalizedNavLink } from '@/shared/ui';
import { useAppDispatch, useAppSelector } from '@/store';
import { setMobileMenuItem, setSidebarExpanded } from '@/store/user-info.slice';

const MobileMenu: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { menu, mobileMenuItem } = useAppSelector((state) => state.userInfo);

  useEffect(() => {
    const filteredItems = menu.filter(
      (item) => !['leasing-scoring', 'contracts'].includes(item.code)
    );
    const foundItem = filteredItems.find((item) =>
      location.pathname.includes(item.code)
    );
    const newMenuItem = foundItem || mobileMenuItem || filteredItems[0];
    if (newMenuItem) {
      dispatch(setMobileMenuItem(newMenuItem));
    }
  }, [location.pathname, menu]);

  return (
    <div className="mobile-menu">
      {menu
        .filter((item) => ['leasing-scoring', 'contracts'].includes(item.code))
        .map((item) => (
          <LocalizedNavLink
            key={item.code}
            to={`/${item.code}`}
            className={({ isActive }) =>
              `mobile-menu__item ${isActive ? 'mobile-menu__item--active' : ''}`
            }
          >
            <img
              className="mobile-menu__link-icon"
              src={item.icon}
              alt={item.name}
            />
            <span>{item.name}</span>
          </LocalizedNavLink>
        ))}
      {mobileMenuItem && (
        <LocalizedNavLink
          to={`/${mobileMenuItem.code}`}
          className={({ isActive }) =>
            `mobile-menu__item ${isActive ? 'mobile-menu__item--active' : ''}`
          }
        >
          <img
            className="mobile-menu__link-icon"
            src={mobileMenuItem.icon}
            alt={mobileMenuItem.name}
          />
          <span>{mobileMenuItem.name}</span>
        </LocalizedNavLink>
      )}
      <button
        className="mobile-menu__item"
        onClick={() => dispatch(setSidebarExpanded(true))}
      >
        <MobileBurgerMenuIcon />
      </button>
    </div>
  );
};

export default MobileMenu;
